module.exports = __webpack_public_path__ + "static/media/loader.83235c52.svg";